import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
import SectionHead from '@/components/SectionHead';
import { TESTIMONIALS } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function Testimonials() {
  return (
    <section id="testimonials" className="relative py-24 sm:py-32 bg-night-surface border-y border-white/5" data-testid="testimonials-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <SectionHead
          chapter="12"
          eyebrow="Testimonials"
          title={'WHAT ASA\nFAMILIES SAY.'}
          testId="testimonials-heading"
        />
        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="grid md:grid-cols-3 gap-6"
        >
          {TESTIMONIALS.map((t, i) => (
            <motion.figure
              key={i} variants={fadeUp} custom={i}
              className="relative rounded-sm border border-dashed border-white/20 bg-night/50 p-8"
              data-testid={`testimonial-${i}`}
            >
              <span className="absolute top-4 right-4 text-[10px] font-bold uppercase tracking-[0.25em] text-gray-500 border border-white/10 rounded-full px-3 py-1">
                Placeholder
              </span>
              <Quote size={28} className="text-brand-gold/60" />
              <blockquote className="mt-5 text-base text-gray-300 leading-relaxed italic">{t.quote}</blockquote>
              <figcaption className="mt-6 text-xs uppercase tracking-[0.25em] text-brand-gold font-semibold">{t.label}</figcaption>
            </motion.figure>
          ))}
        </motion.div>
        <p className="mt-8 text-sm text-gray-500">Real reviews from ASA families will be featured here as they are collected.</p>
      </div>
    </section>
  );
}
